import axios from "axios";

export const Axios = axios.create({
  baseURL: "https://apibb.tmsosial.asia/api/",
  timeout: 10000,
  headers: {},
});
